<template>
  <div class="container_box">
    <!--新增模板-->
    <Button type="primary" @click="addDistributorLevelBtn" style="margin: 5px 0 10px 0;"
      v-if="getPermission('ymsDistributorMerchantGrade_create')">{{ $t('key1003241') }}
    </Button>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        :loading="tableLoading"
        :columns="tableColumns"
        max-height="700"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="curPage"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--客户等级弹窗-->
    <Modal v-model="distributorLevelModal" :title="distributorLevelTitle" width="500"
      :transfer="false" :mask-closable="false" @on-visible-change="distributorLevelModalChange">
      <Form ref="distributorLevelForm" :model="distributorLevelForm" :label-width="120" @submit.native.prevent>
        <Row>
          <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
            <template v-for="item in multilingualNamesList">
              <template :slot="item.name">
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="labelRander(item)" :prop="'name_' + item.code" :rules="getRules(item)">
                    <template v-if="distributorLevelTalg === 'look'">
                      <span class="font-size-12">{{ distributorLevelForm['name_' + item.code] }}</span>
                    </template>
                    <template v-else>
                      <Input clearable v-model.trim="distributorLevelForm['name_' + item.code]" style="width: 80%;"></Input>
                    </template>
                  </Form-item>
                </Col>
              </template>
            </template>
          </languagesTabs>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item
              :label="$t('key1003253')"
              prop="freightDiscount"
              :rules="{ required: true, validator: validateDiscount, trigger: 'change'}">
              <template v-if="distributorLevelTalg === 'look'">
                <span class="font-size-12">{{ distributorLevelForm.freightDiscount }}</span>
              </template>
              <template v-else>
                <InputNumber :placeholder="$t('key1000324')" :max="1" :min="0" :step="0.01" style="width:80%"
                  v-model="distributorLevelForm.freightDiscount" :formatter="(value) => formatterNumber(value, 2)">
                </InputNumber>
              </template>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <template v-if="distributorLevelTalg === 'look'">
          <Button type="primary" @click="distributorLevelModal = false">
            {{ $t('key1000248') }}
          </Button>
        </template>
        <template v-else>
          <Button @click="distributorLevelModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="distributorLevelBtn">
            {{ distributorLevelTalg === 'add' ? $t('key1000111') : $t('key1000555') }}
          </Button>
        </template>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import languagesTabs from "@/components/common/languagesTabs.vue";
import {formatterNumber, isJSON} from "@/utils/common";

export default {
  name: "customerGrade",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      distributorLevelModal: false,
      distributorLevelTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003241'),
      distributorLevelTalg: 'add',
      pageParams: {
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      curPage: 1,
      ymsDistributorMerchantGradeId: null,
      distributorLevelForm: {
        freightDiscount: null
      },
      ruleValidate: {
        name_0: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002715'), trigger: 'blur'}
        ]
      },
      tableColumns: [],
      tableData: [],
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003242') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
    };
  },
  created() {
    this.initMultilingualFields('distributorLevelForm', this.distributorLevelForm, ['name_']);
    this.getList();
  },
  methods: {
    formatterNumber,
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002715'), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.total = 0;
      v.tableData = [];
      v.optionBtnWidth = [];
      v.handleColumns();
      if (v.getPermission('ymsDistributorMerchantGrade_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributorMerchantGrade_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.tableData = data.list || [];
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 新增客户等级
    addDistributorLevelBtn() {
      this.$refs['languagesTab'].tabName = this.languagesVal;
      this.distributorLevelModal = true;
      this.distributorLevelTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003241');
      this.distributorLevelTalg = 'add';
    },
    // 获取客户等级详情
    getLevelDetails(ymsDistributorMerchantGradeId, type) {
      this.ymsDistributorMerchantGradeId = ymsDistributorMerchantGradeId;
      this.axios.get(api.get_ymsDistributorMerchantGrade + ymsDistributorMerchantGradeId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let obj = {
              look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003243'),
              edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003244')
            };
            this.distributorLevelTitle = obj[type];
            this.distributorLevelTalg = type;
            let name = data.name;
            if (name) {
              if (isJSON(name)) {
                let obj = JSON.parse(data.name);
                for (let key in obj) {
                  this.distributorLevelForm['name_' + key] = obj[key];
                }
              } else {
                this.distributorLevelForm['name_CN'] = name;
              }
            }
            this.distributorLevelForm.freightDiscount = Number(data.freightDiscount) || null;
          }
          this.distributorLevelModal = true;
        }
      });
    },
    // 删除客户等级
    deleteDistributorLevelBtn(ymsDistributorMerchantGradeId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003245'),
        onOk: () => {
          v.axios.delete(api.delete_ymsDistributorMerchantGrade + `${ymsDistributorMerchantGradeId}`).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 新增、编辑客户等级确定按钮
    distributorLevelBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      let obj = {};
      // 新增客户等级
      if (v.distributorLevelTalg === 'add') {
        url = api.post_ymsDistributorMerchantGrade_create;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      }
      // 编辑客户等级
      else if (v.distributorLevelTalg === 'edit') {
        url = api.put_ymsDistributorMerchantGrade_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        obj.ymsDistributorMerchantGradeId = v.ymsDistributorMerchantGradeId;
      }
      obj.name = v.handleMultilingualSingleParam(v.distributorLevelForm, 'name_');
      obj.freightDiscount = v.distributorLevelForm.freightDiscount ? Number(v.distributorLevelForm.freightDiscount.toFixed(2)) : null;
      v.$refs['distributorLevelForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.distributorLevelModal = false;
              v.$Message.success(text);
              v.getList();
            }
          });
        }
      });
    },
    // 监听客户等级弹窗(关闭弹窗重置数据)
    distributorLevelModalChange(value) {
      if (!value) {
        this.$refs['distributorLevelForm'].resetFields();
        this.distributorLevelTalg = 'look';
        this.distributorsTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003243');
      } else {
        this.$refs['languagesTab'].tabName = this.languagesVal;
      }
    },
    // 处理列表字段
    handleColumns() {
      let v = this;
      v.tableColumns = [];
      let columns = [
        {
          title: 'NO.',
          key: 'index',
          width: 80,
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002716'),
          key: 'name',
          align: 'center',
          minWidth: 200
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003246'),
          key: 'freightDiscount',
          align: 'center',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003247'),
          key: 'name',
          align: 'center',
          render(h, params) {
            let text = '';
            let isAuto = params.row.isAuto;
            let obj = {
              0: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393'),
              1: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')
            };
            text = obj[isAuto];
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 210,
          render(h, params) {
            let isAutoTalg = params.row.isAuto === 1;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003248'),
                    show: isAutoTalg,
                    color: '#898787',
                    clickFn: () => {

                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002571'),
                    show: !isAutoTalg,
                    clickFn: () => {
                      v.setLevelBtn(params.row.ymsDistributorMerchantGradeId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsDistributorMerchantGrade_detail'),
                    clickFn: () => {
                      v.getLevelDetails(params.row.ymsDistributorMerchantGradeId, 'look');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsDistributorMerchantGrade_update'),
                    clickFn: () => {
                      v.getLevelDetails(params.row.ymsDistributorMerchantGradeId, 'edit');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: !isAutoTalg && v.getPermission('ymsDistributorMerchantGrade_delete'),
                    clickFn: () => {
                      v.deleteDistributorLevelBtn(params.row.ymsDistributorMerchantGradeId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let list = [];
      if (v.multilingualNamesList.length > 0) {
        v.multilingualNamesList.map((item) => {
          let key = 'name_' + item.code;
          let text = '';
          list.push({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003242') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
            key: key,
            align: 'center',
            minWidth: 200,
            render(h, params) {
              let name = params.row.name;
              if (name) {
                if (isJSON(name)) {
                  let obj = JSON.parse(name);
                  text = obj[item.code];
                } else {
                  text = '';
                  if (item.code === 'zh-CN') {
                    text = name;
                  }
                }
              }
              return h('span', text);
            }
          });
        });
      }
      if (list.length > 0) {
        columns.splice(1, 1, ...list);
        v.tableColumns = columns;
      }
    },
    // 设为默认等级
    setLevelBtn(ymsDistributorMerchantGradeId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003249'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003250'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsDistributorMerchantGrade + ymsDistributorMerchantGradeId,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 校验等级折扣系数
    validateDiscount(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003251')));
      } else if (value <= 0 || value > 1) {
        callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003252')));
      } else {
        callback();
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    languagesTabs
  }
};
</script>

<style lang="less" scoped>

</style>
